import { Cart } from "@commercetools/platform-sdk"
import { TFunction } from "i18next"
import { BorgunPaymentApi } from "../../../borgun/BorgunPaymentProvider"
import { ErrorType } from "../../../error/ErrorType"
import { PaymentProvider } from "../../payment/PaymentProviderState"
import { CartValidationBase } from "../../validation/FormValidator"
import {
  captureSentryErrorsAndThrow,
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export class BorgunValidation extends CartValidationBase {
  private readonly paymentError: CartValidationResult
  private readonly borgunPaymentApi: BorgunPaymentApi
  private readonly skip: boolean
  constructor(
    t: TFunction,
    borgunPaymentApi: BorgunPaymentApi,
    currentPaymentProvider: PaymentProvider[]
  ) {
    super("BorgunValidation")
    this.borgunPaymentApi = borgunPaymentApi
    this.paymentError = cartError(ErrorType.PaymentError, {
      title: t("checkout:paymentFailedTitle"),
      message: t("checkout:paymentFailedMessage")
    })
    this.skip = currentPaymentProvider.indexOf(PaymentProvider.Borgun) < 0
  }

  save(c: Cart): CartValidationResult {
    if (this.skip) {
      return super.save(c)
    }
    if (c) {
      return this.borgunPaymentApi
        .pay(c.id)
        .then(response => {
          if (response.status < 400) {
            return super.save(c)
          } else {
            return this.paymentError
          }
        })
        .catch(
          captureSentryErrorsAndThrow("Error processing borgun payment", c?.id)
        )
        .catch(() => this.paymentError)
    } else {
      return this.paymentError
    }
  }
}
